import { render, staticRenderFns } from "./ComprasCreate.vue?vue&type=template&id=76748dda&"
import script from "./ComprasCreate.vue?vue&type=script&lang=js&"
export * from "./ComprasCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports